import React, { useMemo, useState, useEffect, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Grid, Typography, Paper, Button, Tabs, Tab, TableContainer, Table, TableHead, TableRow, TableCell, TableBody } from "@mui/material";
import { useCookies } from "react-cookie";

import {currencyFormatNoDecimals, formatNumberToPercentage, mergeClientCoClientAge} from "../../shared/shared";
import { firstLetterUpperCase } from "../../shared/first-letter-upper";
import { GraphicPie } from "../graphic-pie";
import DinamicTable from "../dinamic-table";

const PresentationCurrentPlan = (props) => {

  const client = useSelector((state) => state.dataStore.get("currentClient"));
  const currentCashInflow = useSelector((state) => state.dataStore.get("currentPlanCashFlow"));
  const successProbabilityCurrent = props.successProbabilityCurrent;
  const [tab, setTab] = useState(4);

  const handleChange = (event, newValue) => {
    setTab(newValue);
  };

  const planDataInflow = useMemo(() => {
    return currentCashInflow?.toJS();
  })

  const defaultContent =
    <Typography fontSize={'13px'} mr={0.8}>
      {props.currentPlanContentText}
    </Typography>

  const defaultFooter = <Typography fontSize={'13px'} mr={0.8}>
    {props.currentPlanFooterText}
  </Typography>

  const TextPlanProbability90 = {
    title: <>
      <Typography fontSize={'13px'} mr={0.8}>The analysis has returned a {<div style={{ color: '#007bef', display: 'inline-block' }}> very secure probability.  </div>}</Typography>
    </>

  }
  const TextPlanProbability7589 = {
    title: <>
      <Typography fontSize={'13px'} mr={0.8}>The analysis has returned a  {<div style={{ color: '#007bef', display: 'inline-block' }}> likely probability.  </div>}</Typography>
    </>,
  }
  const TextPlanProbability75 = {
    title: <>
      <Typography fontSize={'13px'} mr={0.8}>The analysis has returned an {<div style={{ color: '#007bef', display: 'inline-block' }}> uncertain probability.</div>}</Typography>
    </>,
  }



  return (
    <Grid className={"presentation-current-plan"} spacing={3} >
      <Grid container spacing={3}>
        <Grid
          className={"presentation-current-plan-left-panel"}
          item xs={6}
        >
          <Grid className={"presentation-current-plan-client-info"} container alignItems={'center'} >
            <Grid item xs={12}>
              <Grid container justifyContent={"left"}>
                <Typography component={"h3"} variant={"h5"}>
                  {firstLetterUpperCase(client.getIn(["client", "firstName"]))}
                </Typography>
                <Typography component={"h3"} variant={"h5"} style={{ marginLeft: '0.3em' }}>
                  {firstLetterUpperCase(client.getIn(["client", "lastName"]))}
                </Typography>
              </Grid>
            </Grid>
          </Grid>


          <Grid item xs={12}>
            <hr />
          </Grid>
          <Grid container mt={5} >
            <Grid item xs={4} mr={1} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '1em' }}>
              <GraphicPie
                id={"current-plan-id"}
                value={successProbabilityCurrent}
                width={160}
                innerRadius={14}
                numberDistanceX={-5}
                fontSizeNumber={50}
                symbolDistanceX={successProbabilityCurrent >= 100 ? 35 : 25}
                symbolDistanceY={12}
                fontSizeSymbol={25}
              />
            </Grid>
            <Grid item xs={7}>
              {successProbabilityCurrent >= 90 && (
                <>
                  {TextPlanProbability90.title}
                </>
              )}
              {successProbabilityCurrent >= 75 && successProbabilityCurrent <= 89.9 && (
                <>
                  {TextPlanProbability7589.title}

                </>
              )}
              {successProbabilityCurrent <= 74.9 && (
                <>
                  {TextPlanProbability75.title}
                </>
              )}
              {defaultContent}
              {defaultFooter}

            </Grid>
          </Grid>
        </Grid>

        <Grid className={"presentation-current-plan-right-panel"} item xs={6}>
          <Paper elevation={0}>
            <table className={"wealth-summary-table"}>
              <thead>
                <tr>
                  <th>Year</th>
                  <th>Age</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                {props.tableCurrent.map(item => {
                  return (
                    <tr key={item.age}>
                      <td >{item.year}</td>
                      <td >{item.age}</td>
                      <td >{item.endingValue}</td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </Paper>
          <Paper elevation={0}>
            <table className={"tax-summary-table"}>
              <thead>
                <tr >
                  <td className={"text-future-content-year-age-table"}>Paid in Total Taxes</td>
                  <td className={"paid-total-taxes-value"}> {currencyFormatNoDecimals(props.totalTaxesPaid)}</td>
                </tr>

                <tr>
                  <td className="line-table-dashed" colspan="2"></td>
                </tr>

                <tr className={"ss-taxes-row"}>
                  <td className={'text-current-footer-SS-table'}>SS Taxes</td>
                  <td className={'text-future-footer-money-table'}>{currencyFormatNoDecimals(props.totalSS)}</td>
                </tr>
              </thead>
            </table>
          </Paper>
        </Grid>
      </Grid>

      <Grid className={"presentation-current-plan-more-info"} ml={12} justifyContent={"flex-start"} alignItems={"center"} container >
        <Grid item xs={10} m={0} p={0}>
          <Tabs
            style={{ marginTop: "2rem" }}
            indicatorColor={"primary"}
            value={tab}
            onChange={handleChange}
            aria-label="basic tabs example"
          >
            <Tab label="Inflow" />
            <Tab label="Outflow" />
            <Tab label="Accounts Summary" />
            <Tab label="Summary Cash Flow" />
            {tab === 4 ? <Tab style={{ display: 'none' }} /> : null}
          </Tabs>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <div >
          {tab === 0 && (
            <DinamicTable
              data={currentCashInflow.toJS().cashInflow}
              columnTitles={[
                { alignCell: "center", alignHeader: "center", classNameCell: "current-roadmap-cell", key: ["year"], title: "Year" },
                { alignCell: "center", alignHeader: "center", classNameCell: "current-roadmap-cell", key: ["clientAge", "coClientAge"], title: "Client/Spouse", function: mergeClientCoClientAge },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["payroll"], title: "Payroll", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["socialSecurity"], title: "Social Security", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["pension"], title: "Pension", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["other"], title: "Other Income", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["taxDeferredDistributions"], title: "Tax Deferred Dist", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["taxableDistributions"], title: "Taxable Dist", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["taxExemptDistributions"], title: "Tax Exempt Dist", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["fiaWithdrawal"], title: "FIA Withdrawal", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["totalInFlow"], title: "Total Inflows", function: currencyFormatNoDecimals },
              ]}
            />
          )}
          {tab === 1 && (
            <DinamicTable
              columnTitles={[
                { alignCell: "center", alignHeader: "center", classNameCell: "current-roadmap-cell", key: ["year"], title: "Year" },
                { alignCell: "center", alignHeader: "center", classNameCell: "current-roadmap-cell", key: ["clientAge", "coClientAge"], title: "Client/Spouse", function: mergeClientCoClientAge },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["retirementBudget"], title: "Retirement Budget", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["socialSecurityTax"], title: "Social Security Tax", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["capitalGainsTax"], title: "Capital Gains Tax", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["incomeTax"], title: "Income Tax", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["totalOutFlow"], title: "Total Outflows", function: currencyFormatNoDecimals },

              ]}
              data={currentCashInflow.toJS().cashOutflow}
            />
          )
          }
          {tab === 2 && (
            <DinamicTable
              extraHeaderRow={true}
              extraHeaderRowColSpan={[
                { col: 1 },
                { col: 1 },
                { className: 'extra-row-cash-flow', col: 2, title: 'Taxable' },
                { className: 'extra-row-cash-flow', col: 2, title: 'Tax Deferred' },
                { className: 'extra-row-cash-flow', col: 2, title: 'Tax Exempt' },
                { className: 'extra-row-cash-flow', col: 2, title: 'RILA/Vol Buff FIA' },
                { className: 'extra-row-cash-flow', col: 2, title: 'Vol Buff Ins' },
                { className: 'extra-row-cash-flow', col: 1 },
                { col: 1 },
                { col: 1 },
                { col: 1 },
              ]}
              columnTitles={[
                { alignCell: "center", alignHeader: "center", classNameCell: "current-roadmap-cell", key: ["year"], title: "Year" },
                { alignCell: "center", alignHeader: "center", classNameCell: "current-roadmap-cell", key: ["clientAge", "coClientAge"], title: "Client/Spouse", function: mergeClientCoClientAge },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["taxableAccountBalance"], title: "Acct Balance", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["taxableAccountGrossDistribution"], title: "Gross Dist", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["taxDeferredAccountBalance"], title: "Acct Balance", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["taxDeferredAccountGrossDistribution"], title: "Gross Dist", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["taxExemptAccountBalance"], title: "Acct Balance", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["taxExemptAccountGrossDistribution"], title: "Gross Dist", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["fiaAccountBalance"], title: "Acct Balance", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["fiaAccountGrossDistribution"], title: "Gross Dist", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["insuranceNetCashValue"], title: "Net Cash Value", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["insuranceGrossDistribution"], title: "Gross Dist", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["portfolioReturns"], title: "Port Returns", function: (i) => formatNumberToPercentage(i, 2) },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["fiaIndexReturn"], title: "RILA/FIA Return", function: (i) => formatNumberToPercentage(i, 2) },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["insuranceCashValueReturn"], title: "Cash Val Return", function: (i) => formatNumberToPercentage(i, 2) },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["totalAccountValue"], title: "Total Account Value", function: currencyFormatNoDecimals },
              ]}
              data={currentCashInflow.toJS().accountsSummary}
            />
          )
          }
          {tab === 3 && (
            <DinamicTable
              extraHeaderRow={true}
              extraHeaderRowColSpan={[
                { col: 1, className: '', title: '' },
                { col: 1, className: '', title: '' },
                { col: 1, className: '', title: '' },
                { col: 1, className: '', title: '' },
                { col: 1, className: '', title: '' },
                { col: 3, className: 'extra-row-cash-flow', title: 'Taxable' },
                { col: 2, className: 'extra-row-cash-flow', title: 'Tax Deferred' },
                { col: 2, className: 'extra-row-cash-flow', title: 'Tax Exempt' },
                { col: 2, className: 'extra-row-cash-flow', title: 'RILA/Vol Buff FIA' },
                { col: 1, className: 'extra-row-cash-flow', title: 'Vol Buff Ins' },
                { col: 1, className: 'extra-row-cash-flow', title: '' },
                { col: 1, className: '', title: '' },
                { col: 1, className: '', title: '' },
                { col: 1, className: '', title: '' },

              ]}
              columnTitles={[
                { alignCell: "center", alignHeader: "center", classNameCell: "current-roadmap-cell", key: ["year"], title: "Year", },
                { alignCell: "center", alignHeader: "center", classNameCell: "current-roadmap-cell", key: ["clientAge", "coClientAge"], title: "Client/Spouse", function: mergeClientCoClientAge },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["beginningAccountValue"], title: "Beg Acct Value", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["totalInflow"], title: "Total Inflows", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["totalOutflow"], title: "Total Outflows", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["excessIncome"], title: "Excess Income", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["taxableAccountContribution"], title: "Contr", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["grossTaxableDistribution"], title: "Gross Taxable Dist", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["taxDeferredAccountContribution"], title: "Contr", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["grossTaxDeferredDistribution"], title: "Gross Tax Deferred Dist", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["taxExemptAccountContribution"], title: "Contr", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["grossTaxExemptDistribution"], title: "Gross Tax Exempt Dist", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["fiaAccountContribution"], title: "Contr", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["fiaDistribution"], title: "FIA Dist", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["insuranceAccountDistribtuion"], title: "Ins Dist", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["portfolioReturns"], title: "Port Returns", function: (i) => formatNumberToPercentage(i, 2) },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["fiaIndexReturn"], title: "RILA/FIA Return", function: (i) => formatNumberToPercentage(i, 2) },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["insuranceCashValueReturn"], title: "Cash Value Return", function: (i) => formatNumberToPercentage(i, 2) },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["cumulativeWealth"], title: "Cumulative Wealth", function: currencyFormatNoDecimals },

              ]}
              data={currentCashInflow.toJS().cashFlowSummary}
            />
          )}
        </div>
      </Grid>
    </Grid >
  );
};

export default PresentationCurrentPlan;
